export enum RatingOperator {
  NOTUSE = 'Not Use',
  LESS_THAN_OR_EQUAL = 'lessThanOrEqual', // <=
  EQUALS = 'equals', // ==
  GREATER_THAN_OR_EQUAL = 'greaterThanOrEqual', // >=
}

export class MAINFILTER {

  ID: number;
  CriteriaName: string;

  VQuad_Location: string;
  VQuad_PhoneID: string;
  VQuad_CallID: string;
  Called_Number: string;

  PESQ_LQ_Rating: string;
  POLQA_Score_Rating: string;
  RTD_Rating: string;
  MOSCQ_Rating: string;

  Timezone: string;
  Failed_Calls: string;

  PESQ_LQ_Range: string;
  POLQA_Score_Range: string;
  MOSCQ_Range: string;
  RTD_Range: string;
  OWD_Range: string;
  SNR_Range: string;
  PDD_Range: string;

  Call_Control_Event: string;
  CC_Condition: string;

  //PESQ/POLQA Advanced criteria
  CriteriaCondition: string;
  POLQACriteriaCondition: string;

  ////PESQ/POLQA type - NOT IN USE
  //TableType: number;
  ////Updates as new or copy name - NOT IN USE
  //UpdateStatus: number;

  ////ColumSetup-NOT IN USE
  //SelectedColumn: string;
  //POLQASelectedColumn: string;

  CustomDateTime: string;

  NetTest: string;
  Mobile: string;

  MapRegion: string;

  constructor() {
    this.ID = 0;
    this.CriteriaName = "";

    this.VQuad_Location = "";
    this.VQuad_PhoneID = "";
    this.VQuad_CallID = "";
    this.Called_Number = "";

    this.PESQ_LQ_Rating = "0|0";
    this.POLQA_Score_Rating = "0|0";
    this.RTD_Rating = "0|0";
    this.MOSCQ_Rating = "0";

    this.Timezone = "False";
    this.Failed_Calls = "False";

    this.PESQ_LQ_Range = "|";
    this.POLQA_Score_Range = "|";
    this.MOSCQ_Range = "|";
    this.RTD_Range = "|";
    this.OWD_Range = "|";
    this.SNR_Range = "|";
    this.PDD_Range = "|";

    this.Call_Control_Event = "";
    this.CC_Condition = "";

    this.CriteriaCondition = "";
    this.POLQACriteriaCondition = "";

    this.CustomDateTime = "";

    this.NetTest = ";;;;;;;;";
    this.Mobile = ";;";

    this.MapRegion = "";
  }

}
